<template>
  <div
    class="mx-4 text-xs text-left grid grid-cols-8 border-b dark:bg-dark-800 dark:text-dark-text dark:border-dark-300 bg-white border-gray-300 text-gray-600"
    style="padding-left: 44px"
  >
    <div class="py-2 px-2 text-center col-span-2">
      {{ $t('message.judgeId') }}
    </div>
    <div class="py-2 px-2 text-center">
      {{ $t('message.status') }}
    </div>
    <div class="py-2 px-2 text-center col-span-2">
      {{ $t('message.language') }}
    </div>
    <div class="py-2 px-2 text-center col-span-3"> {{ $t('message.submitDate') }}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  setup() {
    return {}
  }
})
</script>

<style lang="postcss" scoped></style>
